import { WsEpisodeApi } from 'api/ApiHelper';
import { studioQueryKey } from 'queries/studio/queryKey';
import { useQuery } from '@tanstack/react-query';

export const useGetWsEpisodeFirstOpenedInMonthQuery = (yearMonth: string) =>
  useQuery({
    queryKey: studioQueryKey.wsEpisodeOpenedInMonth(yearMonth),
    queryFn: () => WsEpisodeApi.findFirstOpenedInMonth(yearMonth),
  });
